import actions from "@/store/modules/youtube/actions";
import mutations from "@/store/modules/youtube/mutations";
import state from "@/store/modules/youtube/state";

export default {
    actions,
    mutations,
    state
}